import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

const namespaced = true;

export { namespaced, actions, getters, mutations, state };
